import { Navigate } from 'react-router-dom';

export function NotFoundRedirect() {
  return <Navigate to="/app" replace />;
}
